import React from "react";
import { findAllAcademicPartWithTemplateFormByIdAndByTermWithTotalEvent } from "../../_events/academic_parts/find.event";
import { alertError } from "../../_utils/alerts";

export const useAcademicPartAllWithTemplateFormByIdAndTerm = (id, term) => {
  const [data, setData] = React.useState([]);
  const [total, setTotal] = React.useState(0);

  const loadData = (i, t) => {
    findAllAcademicPartWithTemplateFormByIdAndByTermWithTotalEvent(i, t)
      .then((json) => {
        setData(json.data.tree.list);
        // IS ZERO!
        setTotal(json.data.tree.total);
      })
      .catch((err) => {
        alertError(err.message);
      });
  };

  React.useEffect(() => {
    loadData(id, term);
  }, [id, term]);

  return { data, total, loadData };
};
